import React, { FunctionComponent } from "react"
import Layout from "../../components/Layout"
import Seo from "../../components/Seo"
import Pill from "../../components/Pill"
import Container from "../../components/Container"
import { graphql } from "gatsby"
import ActionPanel from "../../components/home/ActionPanel"
import SignUpForm from "../../components/SignUpForm"
import { MDXRenderer } from "gatsby-plugin-mdx"
import "./index.module.css"

interface QueryResult {
  mdx: {
    frontmatter: {
      title: string
      seo: {
        title: string
        description: string
      }
    }
    body: string
  }
}

interface Props {
  data: QueryResult
}

const CustomerTermsPage: FunctionComponent<Props> = ({ data }) => {
  const page = data.mdx
  return (
    <Layout>
      <Seo
        description={page.frontmatter.seo.description}
        pathname="/customer-terms"
        title={page.frontmatter.seo.title}
      />

      <header>
        <Pill bgClass="bg-green-100" variant="center-right">
          <Container>
            <div className="br-prose py-24 xxl:py-32">
              <div className="br-col-gap md:grid md:grid-cols-12">
                <div className="md:col-span-10 md:col-start-2 xxl:col-span-8 xxl:col-start-3">
                  <h1 className="mb-8 text-center">{page.frontmatter.title}</h1>
                </div>
              </div>
            </div>
          </Container>
        </Pill>
      </header>
      <section className="pt-24">
        <Container>
          <div className="br-col-gap md:grid md:grid-cols-12">
            <div className="md:col-span-10 md:col-start-2 xxl:col-span-8 xxl:col-start-3">
              <div className="customer-terms br-prose">
                <div className="doc-content">
                  <p>Effective Date: 27/08/24.</p>
                  <p>
                    Previous versions:{" "}
                    <a href="/customer-terms-2021">20/08/21</a>
                    <br />
                    <br />
                  </p>
                  <p class="c28 c10">
                    <span class="c11">
                      PLEASE READ THESE BREEZY ONLINE TERMS OF SERVICE CAREFULLY
                      BEFORE ACCEPTING THEM AS YOUR USE OF AND ACCESS TO OUR
                      SERVICES (DEFINED BELOW) IS SUBJECT TO ALL OF THESE TERMS.
                    </span>
                  </p>
                  <p class="c28 c10">
                    <span class="c11">
                      IF YOU DO NOT WISH TO BE BOUND BY THESE BREEZY CUSTOMER
                      TERMS OR DO NOT AGREE TO ALL OF THESE TERMS, YOU MUST NOT
                      USE OR ACCESS THE SERVICES IN ANY MANNER.
                    </span>
                  </p>
                  <p class="c28 c10">
                    <span class="c0">
                      These Breezy Online Terms of Services govern the Services
                      made available on our platform at&nbsp;
                    </span>
                    <span class="c0 c32">
                      <a class="c18" href="https://breezy.io">
                        breezy.io
                      </a>
                    </span>
                    <span class="c0">
                      , a website operated by Partnered Ltd trading as
                      &lsquo;Breezy&rsquo;. The terms governing the Website are
                      available&nbsp;
                    </span>
                    <span class="c4 c36">
                      <a class="c18" href="https://breezy.io/website-terms">
                        here
                      </a>
                    </span>
                    <span class="c2 c0">.</span>
                  </p>
                  <p class="c10 c28">
                    <span class="c0">
                      If you have any questions, comments, or concerns regarding
                      these terms or the Services, please contact us at&nbsp;
                    </span>
                    <span class="c0 c12">
                      <a class="c18" href="mailto:support@breezy.io">
                        support@breezy.io
                      </a>
                    </span>
                    <span class="c0">.</span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0 start" start="1">
                    <li class="c1 c13 li-bullet-0" id="h.4hr1b5p">
                      <span class="c4">Interpretation</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.2wwbldi">
                      <span class="c2 c0">
                        The definitions and rules of interpretation in this
                        clause apply in this agreement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_6-0 start" start="1">
                    <li class="c5">
                      <span class="c11">Add-ons: </span>
                      <span class="c0">
                        any &lsquo;add-ons&rsquo; on &lsquo;bolt-ons&rsquo; as
                        described in the{" "}
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}
                        and agreed by the parties in writing from time to time.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_3-0" start="2">
                    <li class="c5">
                      <span class="c11">Agreed Threshold: </span>
                      <span class="c0">the</span>
                      <span class="c11">&nbsp;</span>
                      <span class="c0">
                        number of Contact Credits available
                        to the Customer in a month under its Plan.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c2 c11">
                        Applicable Data Protection Laws:{" "}
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c2 c0">
                        (a)&nbsp;To the extent the UK GDPR (as defined in the
                        Data Protection Act 2018) applies, the law of the United
                        Kingdom or of a part of the United Kingdom which relates
                        to the protection of Personal&nbsp;Data.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c0">
                        (b)&nbsp;To the extent the
                        General&nbsp;Data&nbsp;Protection Regulation ((EU)
                        2016/679) (
                      </span>
                      <span class="c11">GDPR</span>
                      <span class="c2 c0">
                        ) applies, the law of the European Union or any member
                        state of the European Union to which the Customer or
                        Breezy is subject, which relates to the protection of
                        personal&nbsp;data.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Authorised Users: </span>
                      <span class="c2 c0">
                        those employees, agents and independent contractors of
                        the Customer who are authorised by the Customer to use
                        the Services and the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} and, where the User
                        Status is that of an Agency or Partner Network,
                        including employees, agents and independent contractors
                        of clients of the Customer.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Breezy Data:</span>
                      <span class="c2 c0">
                        &nbsp;all data and other information provided to the
                        Customer or its Authorised Users via the Service,
                        including in response to Search and Contact Requests and
                        in relation to an Ecosystem.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Business Day: </span>
                      <span class="c2 c0">
                        a day other than a Saturday, Sunday or public holiday in
                        England when banks in London are open for business.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Contact: </span>
                      <span class="c0">
                        the contact details of a person provided pursuant to the
                        Services comprising the following where possible: name,
                        company, job title, direct email, generic email, and
                        LinkedIn profile URL.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Contract Term: </span>
                      <span class="c2 c0">the term of this agreement.</span>
                    </li>
                    <li class="c5">
                      <span class="c11">Customer:</span>
                      <span class="c2 c0">&nbsp;Breezy&rsquo;s customer.</span>
                    </li>
                    <li class="c5">
                      <span class="c11">Customer Data: </span>
                      <span class="c2 c0">
                        the data provided to Breezy by the Customer or
                        Authorised Users on the Customer&#39;s behalf for the
                        purpose of using the Services or facilitating the
                        Customer&#39;s use of the Services.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Data Subject: </span>
                      <span class="c2 c0">
                        the meaning given in EU regulation 2016/679
                        (&ldquo;GDPR&rdquo;).
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Data Subject Rights Exercise: </span>
                      <span class="c2 c0">
                        the exercise by a Data Subject of any of their rights as
                        defined in Articles 15 to 22 of the GDPR.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11"><a href="https://breezy.io/platform-documentation">{" "}
                          Platform Documentation
                        </a>{" "}: </span>
                      <span class="c0">
                        the documents made available to the Customer by Breezy
                        on the Platform which set out a description of the
                        Services and the user instructions for the Services, as
                        amended from time to time by Breezy by giving at least
                        14 days&#39; notice to the Client{" "}
                      </span>
                      <span class="c0 c33">Link here: </span>
                      <span class="c4 c6">
                        <a class="c18" href="https://breezy.io/platform-docs">
                          Platform Documentation
                        </a>
                      </span>
                      <span class="c11">.</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_6-0" start="2">
                    <li class="c5">
                      <span class="c11">Ecosystem: </span>
                      <span class="c2 c0">
                        each ecosystem available to the Customer pursuant to its
                        Services Plan, as defined in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} and as
                        agreed in writing by the parties from time to time.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Effective Date: </span>
                      <span class="c2 c0">
                        the date on which the Customer subscribes for the
                        Services..
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Fees: </span>
                      <span class="c2 c0">
                        the fees payable by the Customer to Breezy for the
                        Services Plan and any Add-ons as specified in the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_3-0" start="16">
                    <li class="c5">
                      <span class="c11">Group Company</span>
                      <span class="c0">
                        : in relation to a party, any entity that directly or
                        indirectly controls, is controlled by, or is under
                        common control with that party from time to time.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">
                        Heightened Cybersecurity Requirements:{" "}
                      </span>
                      <span class="c2 c0">
                        any laws, regulations, codes, guidance (from regulatory
                        and advisory bodies. Whether mandatory or not),
                        international and national standards, industry schemes
                        and sanctions, which are applicable to either the
                        Customer or an Authorised User relating to security of
                        network and information systems and security breach and
                        incident reporting requirements, which may include the
                        cybersecurity Directive ((EU) 2016/1148), Commission
                        Implementing Regulation ((EU) 2018/151), the Network and
                        Information systems Regulations 2018 (SI 506/2018), all
                        as amended or updated from time to time.
                      </span>
                    </li>
                    <li class="c30">
                      <span class="c11">Ideal Partner Profile: </span>
                      <span class="c0">
                        the type of entity that the Customer identifies on the
                        Platform as an ideal partner. This includes geographic
                        location, demographic, or type of potential partner.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Mandatory Policies: </span>
                      <span class="c2 c0">
                        Breezy&#39;s policies and codes available on the
                        Platform from time to time.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Normal Business Hours: </span>
                      <span class="c2 c0">
                        8.00 am to 6.00 pm local UK time, each Business Day.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_6-0" start="5">
                    <li class="c5">
                      <span class="c11">Payment Details: </span>
                      <span class="c0">
                        the payment information provided by the Customer at the
                        start or end of the Trial Period.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_3-0" start="21">
                    <li class="c5">
                      <span class="c11">Permitted Purposes:</span>
                      <span class="c0">
                        &nbsp;The processing of Personal Data for the following
                        purposes:
                      </span>
                    </li>
                  </ol>
                  <ul class="c3 lst-kix_list_1-0 start">
                    <li class="c34 li-bullet-1">
                      <span class="c2 c0">
                        Service Delivery: Facilitating the provision of services
                        agreed upon in the Contract, including customer support
                        and communication.
                      </span>
                    </li>
                    <li class="c21 li-bullet-2">
                      <span class="c2 c0">
                        Contract Management: Administering and managing the
                        contractual relationship between Breezy and the
                        Customer, including billing, payments, and
                        record-keeping.
                      </span>
                    </li>
                    <li class="c21 li-bullet-2">
                      <span class="c2 c0">
                        Performance Analysis: Analysing and improving the
                        performance and quality of the services provided.
                      </span>
                    </li>
                    <li class="c21 li-bullet-2">
                      <span class="c2 c0">
                        Compliance: Ensuring compliance with applicable laws,
                        regulations, and contractual obligations.
                      </span>
                    </li>
                    <li class="c21 li-bullet-1">
                      <span class="c2 c0">
                        Marketing: Conducting marketing and promotional
                        activities, subject to obtaining any necessary consents.
                      </span>
                    </li>
                    <li class="c21 li-bullet-1">
                      <span class="c2 c0">
                        Security: Protecting the security and integrity of the
                        systems and data, including preventing unauthorised
                        access and ensuring data privacy.
                      </span>
                    </li>
                    <li class="c27 li-bullet-2">
                      <span class="c2 c0">
                        Research and Development: Conducting research and
                        development to improve existing services and develop new
                        services, provided the data is anonymized where
                        possible.
                      </span>
                    </li>
                  </ul>
                  <ol class="c3 lst-kix_list_3-0" start="22">
                    <li class="c5">
                      <span class="c11">Platform: </span>
                      <span class="c0">
                        Breezy&rsquo;s platform at https://breezy.io
                      </span>
                      <span class="c0 c26">&nbsp;</span>
                      <span class="c2 c0">
                        or such other web address as is notified by Breezy to
                        the Customer from time to time.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Quarter: </span>
                      <span class="c0">
                        each successive period of three months following the
                        Effective Date.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Request: </span>
                      <span class="c0">
                        a request for a Search or a Contact or a request for the
                        refresh of a Search or for an Ecosystem made by the
                        Customer via the Platform or in writing.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Search:</span>
                      <span class="c2 c0">
                        &nbsp;a search available to the Customer pursuant to its
                        Services Plan, as defined in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Search Validity Period:</span>
                      <span class="c2 c0">
                        &nbsp;the applicable validity period specified in the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Services: </span>
                      <span class="c2 c0">
                        the subscription services provided by Breezy to the
                        Customer under this agreement via the Platform, as more
                        particularly described in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} in relation
                        to the Services Plan.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Software: </span>
                      <span class="c2 c0">
                        the online software applications provided by Breezy as
                        part of the Services.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_5-0 start" start="1">
                    <li class="c5">
                      <span class="c11">Services Period: </span>
                      <span class="c0">the services period</span>
                      <span class="c11">&nbsp;</span>
                      <span class="c0">specified</span>
                      <span class="c11">&nbsp;</span>
                      <span class="c2 c0">
                        in relation to the Services Plan or as otherwise agreed
                        by the parties in writing from time to time.
                      </span>
                    </li>
                  </ol>
                  <p class="c16">
                    <span class="c11">Services Plan: </span>
                    <span class="c0">
                      the Services Plan selected by the Customer on subscription
                      for the Services as varied &nbsp;by written agreement of
                      the parties from time to time.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_3-0" start="29">
                    <li class="c5">
                      <span class="c11">Support Services Policy: </span>
                      <span class="c2 c0">
                        Breezy&#39;s policy for providing support in relation to
                        the Services as made available on the Platform.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_6-0" start="6">
                    <li class="c5">
                      <span class="c11">Trial Period:</span>
                      <span class="c0">
                        &nbsp;the period of seven days following the Effective
                        Date.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">User Status</span>
                      <span class="c0">
                        : as stated by the Customer in the course of subscribing
                        for the Services.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_3-0" start="30">
                    <li class="c5">
                      <span class="c11">Virus: </span>
                      <span class="c2 c0">
                        any thing or device (including any software, code, file
                        or programme) which may: prevent, impair or otherwise
                        adversely affect the operation of any computer software,
                        hardware or network, any telecommunications service,
                        equipment or network or any other service or device;
                        prevent, impair or otherwise adversely affect access to
                        or the operation of any programme or data, including the
                        reliability of any programme or data (whether by
                        rearranging, altering or erasing the programme or data
                        in whole or part or otherwise); or adversely affect the
                        user experience, including worms, trojan horses, viruses
                        and other similar things or devices.
                      </span>
                    </li>
                    <li class="c5">
                      <span class="c11">Vulnerability: </span>
                      <span class="c2 c0">
                        a weakness in the computational logic (for example,
                        code) found in software and hardware components that
                        when exploited, results in a negative impact to the
                        confidentiality, integrity, or availability, and the
                        term Vulnerabilities shall be interpreted accordingly.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.1c1lvlb">
                      <span class="c2 c0">
                        Clause headings shall not affect the interpretation of
                        this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.3w19e94">
                      <span class="c2 c0">
                        A person includes an individual, corporate or
                        unincorporated body (whether or not having separate
                        legal personality) and that person&#39;s legal and
                        personal representatives, successors or permitted
                        assigns.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2b6jogx">
                      <span class="c2 c0">
                        A reference to a company shall include any company,
                        corporation or other body corporate, wherever and
                        however incorporated or established.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.qbtyoq">
                      <span class="c2 c0">
                        Unless the context otherwise requires, words in the
                        singular shall include the plural and in the plural
                        shall include the singular.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.3abhhcj">
                      <span class="c2 c0">
                        Unless the context otherwise requires, a reference to
                        one gender shall include a reference to the other
                        genders.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.1pgrrkc">
                      <span class="c2 c0">
                        A reference to a statute or statutory provision is a
                        reference to it as it is in force as at the date of this
                        agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.49gfa85">
                      <span class="c2 c0">
                        A reference to a statute or statutory provision shall
                        include all subordinate legislation made as at the date
                        of this agreement under that statute or statutory
                        provision.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2olpkfy">
                      <span class="c0">A reference to </span>
                      <span class="c11">writing</span>
                      <span class="c0">&nbsp;or </span>
                      <span class="c11">written</span>
                      <span class="c2 c0">
                        &nbsp;excludes fax but not email.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.13qzunr">
                      <span class="c2 c0">
                        References to clauses are to the clauses of this
                        agreement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="2">
                    <li class="c1 c13 li-bullet-0" id="h.3nqndbk">
                      <span class="c4">Authorised Users</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.22vxnjd">
                      <span class="c2 c0">
                        Subject to the terms and conditions of this agreement,
                        Breezy hereby grants to the Customer a non-exclusive,
                        non-transferable right and licence, without the right to
                        grant sublicences, to permit the Authorised Users to
                        use:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0">
                      <span class="c2 c0">
                        the Services and the <a href="https://breezy.io/platform-documentation">{" "}
                          Platform Documentation
                        </a>{" "} during the Contract
                        Term; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0">
                      <span class="c0">if applicable, each </span>
                      <span class="c0">Search </span>

                      <span class="c2 c0">for the Search Validity Period.</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.i17xr6">
                      <span class="c2 c0">
                        In relation to the Authorised Users, the Customer
                        undertakes that each Authorised User shall keep a secure
                        password for their use of the Services and {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}
                        and that each Authorised User shall keep their password
                        confidential.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.320vgez">
                      <span class="c2 c0">
                        The Customer shall not access, store, distribute or
                        transmit any Viruses, or any material during the course
                        of its use of the Services that:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.1h65qms">
                      <span class="c2 c0">
                        is unlawful, harmful, threatening, defamatory, obscene,
                        infringing, harassing or racially or ethnically
                        offensive;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.415t9al">
                      <span class="c2 c0">facilitates illegal activity;</span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.2gb3jie">
                      <span class="c2 c0">
                        depicts sexually explicit images;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.vgdtq7">
                      <span class="c2 c0">promotes unlawful violence;</span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3fg1ce0">
                      <span class="c2 c0">
                        is discriminatory based on race, gender, colour,
                        religious belief, sexual orientation, disability; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.1ulbmlt">
                      <span class="c2 c0">
                        is otherwise illegal or causes damage or injury to any
                        person or property;
                      </span>
                    </li>
                  </ol>
                  <p class="c16">
                    <span class="c2 c0">
                      and Breezy reserves the right, without liability or
                      prejudice to its other rights to the Customer, to disable
                      the Customer&#39;s access to any material that breaches
                      the provisions of this clause.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-1" start="4">
                    <li class="c1 li-bullet-0" id="h.4ekz59m">
                      <span class="c2 c0">The Customer shall not:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.2tq9fhf">
                      <span class="c2 c0">
                        except as may be allowed by any applicable law which is
                        incapable of exclusion by agreement between the parties
                        and except to the extent expressly permitted under this
                        agreement:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-3 start" start="1">
                    <li class="c17 li-bullet-0" id="h.18vjpp8">
                      <span class="c2 c0">
                        attempt to copy, modify, duplicate, create derivative
                        works from, frame, mirror, republish, download, display,
                        transmit, or distribute all or any portion of the
                        Software and/or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} (as applicable) in any
                        form or media or by any means; or
                      </span>
                    </li>
                    <li class="c17 li-bullet-0" id="h.3sv78d1">
                      <span class="c2 c0">
                        attempt to de-compile, reverse compile, disassemble,
                        reverse engineer or otherwise reduce to
                        human-perceivable form all or any part of the Software;
                        or
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2" start="2">
                    <li class="c7 li-bullet-0" id="h.280hiku">
                      <span class="c2 c0">
                        access all or any part of the Services and <a href="https://breezy.io/platform-documentation">{" "}
                          Platform Documentation
                        </a>{" "}
                        in order to build a product or service which competes
                        with the Services and/or the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.n5rssn">
                      <span class="c0 c2">
                        subject to clause 20.1, licence, sell, rent, lease,
                        transfer, assign, distribute, display, disclose, or
                        otherwise commercially exploit, or otherwise make the
                        Services and/or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} available to any third
                        party except the Authorised Users; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.375fbgg">
                      <span class="c2 c0">
                        attempt to obtain, or assist third parties in obtaining,
                        access to the Services and/or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}, other than
                        as provided under this clause 2; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.1maplo9">
                      <span class="c2 c0">
                        introduce or permit the introduction of, any Virus or
                        Vulnerability into Breezy&#39;s network and information
                        systems.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="5">
                    <li class="c1 li-bullet-0" id="h.46ad4c2">
                      <span class="c2 c0">
                        The Customer shall only use the Services and/or
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} to provide services to third parties where
                        expressly authorised in writing by Breezy to do so and
                        in the event of such authorisation shall only be
                        authorised to use each Contact to provide its services
                        in relation to one third party.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0">
                      <span class="c2 c0">
                        The Customer shall prevent any unauthorised access to,
                        or use of, the Services and/or the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} and, in
                        the event of any such unauthorised access or use,
                        promptly notify Breezy.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2lfnejv">
                      <span class="c0">
                        The rights provided under this clause are granted to the
                        Customer only
                      </span>
                      <span class="c0">
                        &nbsp;unless Breezy confirms in writing that such rights
                        are also granted to Group Companies
                      </span>

                      <span class="c2 c0">.</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="3">
                    <li class="c1 c13 li-bullet-0" id="h.10kxoro">
                      <span class="c4">Services</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.3kkl7fh">
                      <span class="c2 c0">
                        Breezy shall, during the Contract Term, provide the
                        Services and any Add-Ons and make available the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} to the Customer on and subject to the
                        terms of this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.1zpvhna">
                      <span class="c2 c0">
                        Breezy shall use commercially reasonable endeavours to
                        make the Services available 24 hours a day, seven days a
                        week, except for:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.4jpj0b3">
                      <span class="c2 c0">
                        planned maintenance carried out during the maintenance
                        window of 10.00 pm to 2.00 am UK time; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.2yutaiw">
                      <span class="c2 c0">
                        unscheduled maintenance performed outside Normal
                        Business Hours, provided that Breezy has used reasonable
                        endeavours to give the Customer at least 6 Normal
                        Business Hours&#39; notice in advance.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="3">
                    <li class="c1 li-bullet-0" id="h.1e03kqp">
                      <span class="c2 c0">
                        Breezy will, as part of the Services and at no
                        additional cost to the Customer, provide the Customer
                        with Breezy&#39;s standard customer support services
                        during Normal Business Hours in accordance with
                        Breezy&#39;s Support Services Policy in effect at the
                        time that the Services are provided. Breezy may amend
                        the Support Services Policy in its sole and absolute
                        discretion from time to time. The Customer may purchase
                        enhanced support services separately at Breezy&#39;s
                        then current rates.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="4">
                    <li class="c1 c13 li-bullet-0" id="h.3xzr3ei">
                      <span class="c4">Data protection</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c15 li-bullet-3" id="h.3fwokq0">
                      <span class="c0">
                        Breezy and the Customer may share Personal Data relating
                        to Contacts for the Permitted Purposes. &nbsp;Each party
                        will Process personal data shared between the parties
                        pursuant to this agreement as an independent controller
                        strictly for the purposes stated in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}.{" "}
                      </span>

                      <span class="c2 c0">&nbsp;</span>
                    </li>
                    <li class="c1 li-bullet-0">
                      <span class="c2 c0">
                        Each party undertakes that it will comply with
                        Applicable Data Protection Law at all times during the
                        term of the Agreement, which will include: (i)
                        Processing the Data in compliance with Applicable Data
                        Protection Laws and (ii) providing Data Subjects with
                        all the information required pursuant to Applicable Data
                        Protection Laws to ensure that they understand how their
                        Personal Data will be Processed by that party.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.sabnu4">
                      <span class="c2 c0">
                        Breezy will have in place appropriate technical and
                        organisational measures to ensure a level of security
                        appropriate to the risks that are presented by its
                        processing of the Personal Data that are under its
                        control, in particular against accidental or unlawful
                        destruction, loss, alteration, unauthorised disclosure,
                        or access.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.3c9z6hx">
                      <span class="c2 c0">
                        The parties agree that each will maintain its own
                        contact point for Data Subjects and that each party will
                        make all reasonable efforts to assist the other in
                        complying with requests from Data Subjects to exercise
                        their rights under Applicable Data Protection Laws.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2u6wntf">
                      <span class="c2 c0">
                        Each Party agrees to provide such reasonable assistance
                        as is necessary to the other to enable the other party
                        to comply with any Data Subject Rights Exercise (whether
                        in relation to access to Personal Data, rectification,
                        restrictions on Processing, erasure or portability or
                        any other right) and to respond to any other queries or
                        complaints from Data Subjects in accordance with the
                        Applicable Data Protection Laws.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.4bewzdj">
                      <span class="c2 c0">
                        The Customer understands that in providing the Services
                        and supplying the Customer with Breezy Data, Breezy
                        maintains enduring data protection obligations to the
                        Data Subjects whose personal data may form part of the
                        Breezy Data (depending on the Services used by the
                        Customer). &nbsp;Accordingly, the Customer undertakes to
                        abide by the limits on permissible use of the Breezy
                        Data set out in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} in particular:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.2qk79lc">
                      <span class="c2 c0">
                        the prohibition upon the Customer re-selling Breezy Data
                        or making it available for use by a third party other
                        than a person with User Status;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.15phjt5">
                      <span class="c2 c0">
                        not using the Breezy Data, directly or indirectly, as a
                        primary source of training, fine-tuning, or otherwise
                        enhancing Large Language Models (LLMs) or any other
                        Artificial Intelligence (AI) platforms developed or used
                        by Customer. This restriction applies to all Breezy
                        Data, regardless of whether it is obtained during the
                        term of this agreement or prior to it. Customer shall
                        take all reasonable measures to prevent the use of
                        Breezy Data in a manner that would contribute to the
                        training or improvement of LLMs or AI platforms; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3pp52gy">
                      <span class="c2 c0">
                        immediately to cease use of any Personal Data upon
                        notification by Breezy (by way of the lead being tagged
                        with a &ldquo;opted-out&rdquo; label in the platform)
                        that that Data Subject objects to use of his/her
                        personal data in the manner contemplated by this
                        agreement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="7">
                    <li class="c1 li-bullet-0" id="h.24ufcor">
                      <span class="c2 c0">
                        Breezy has implemented stringent Data Protection
                        Policies in relation to the provision of Contact
                        information. Contacts are issued an opt-out notice prior
                        to their details being uploaded into the Breezy platform
                        and provided to a customer.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.jzpmwk">
                      <span class="c2 c0">
                        Where a Data Subject opts-out, the applicable Contact
                        Credit will be refunded to the Customer account.
                        &nbsp;The Customer accepts liability for any use of
                        details of a Data Subject after receipt of notification
                        of opt-out.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="5">
                    <li class="c1 c13 li-bullet-0">
                      <span class="c4">Third party providers</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.33zd5kd">
                    <span class="c2 c0">
                      The Customer acknowledges that the Services may enable or
                      assist it to access the website content of, correspond
                      with, and purchase products and services from, third
                      parties via third-party websites and that it does so
                      solely at its own risk. Breezy makes no representation,
                      warranty or commitment and shall have no liability or
                      obligation whatsoever in relation to the content or use
                      of, or correspondence with, any such third-party website,
                      or any transactions completed, and any contract entered
                      into by the Customer, with any such third party. Any
                      contract entered into and any transaction completed via
                      any third-party website is between the Customer and the
                      relevant third party, and not Breezy. Breezy recommends
                      that the Customer refers to the third party&#39;s website
                      terms and conditions and privacy policy prior to using the
                      relevant third-party website. Breezy does not endorse or
                      approve any third-party website nor the content of any of
                      the third-party website made available via the Services.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="6">
                    <li class="c1 c13 li-bullet-0" id="h.1j4nfs6">
                      <span class="c4">Breezy&#39;s obligations</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.434ayfz">
                      <span class="c2 c0">
                        Breezy undertakes that the Services and the Add-Ons will
                        be performed substantially in accordance with the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} and with reasonable skill and care.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2i9l8ns">
                      <span class="c2 c0">
                        The undertaking at clause 6.1 shall not apply to the
                        extent of any non-conformance which is caused by use of
                        the Services and/or Add-Ons contrary to Breezy&#39;s
                        instructions, or modification or alteration of the
                        Services and/or Add-ons by any party other than Breezy
                        or Breezy&#39;s duly authorised contractors or agents.
                        If the Services and/or Add-Ons do not conform with the
                        foregoing undertaking, Breezy will, at its expense, use
                        all reasonable commercial endeavours to correct any such
                        non-conformance promptly, or provide the Customer with
                        an alternative means of accomplishing the desired
                        performance. Such correction or substitution constitutes
                        the Customer&#39;s sole and exclusive remedy for any
                        breach of the undertaking set out in clause 6.1.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.xevivl">
                      <span class="c2 c0">Breezy:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.3hej1je">
                      <span class="c2 c0">does not warrant that:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-3 start" start="1">
                    <li class="c17 li-bullet-0" id="h.1wjtbr7">
                      <span class="c2 c0">
                        the Customer&#39;s use of the Services will be
                        uninterrupted or error-free; or
                      </span>
                    </li>
                    <li class="c17 li-bullet-0" id="h.4gjguf0">
                      <span class="c2 c0">
                        that the Services, Add-Ons, <a href="https://breezy.io/platform-documentation">{" "}
                          Platform Documentation
                        </a>{" "} and/or Breezy
                        Data will meet the Customer&#39;s requirements;
                      </span>
                    </li>
                    <li class="c17 li-bullet-0">
                      <span class="c2 c0">
                        Each Contact will be complete and accurate; or the
                        Software or the Services will be free from
                        Vulnerabilities or Viruses; or
                      </span>
                    </li>
                    <li class="c17 li-bullet-0" id="h.2vor4mt">
                      <span class="c2 c0">
                        the Software, {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}, Add-Ons or Services will
                        comply with any Heightened Cybersecurity Requirements.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2" start="2">
                    <li class="c7 li-bullet-0" id="h.1au1eum">
                      <span class="c2 c0">
                        is not responsible for any delays, delivery failures, or
                        any other loss or damage resulting from the transfer of
                        data over communications networks and facilities,
                        including the internet, and the Customer acknowledges
                        that the Services, Add-Ons and {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} may be
                        subject to limitations, delays and other problems
                        inherent in the use of such communications facilities.
                      </span>
                    </li>
                    <li class="c7 li-bullet-0">
                      <span class="c2 c0">
                        is under no obligation to provide any Add-On, Ecosystem,
                        Search or Contact until it has been paid in full for
                        that Ecosystem, Search or Contact.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="4">
                    <li class="c1 li-bullet-0" id="h.3utoxif">
                      <span class="c2 c0">
                        This agreement shall not prevent Breezy from entering
                        into similar agreements with third parties, or from
                        independently developing, using, selling or licensing
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}, products and/or services which are
                        similar to those provided under this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.29yz7q8">
                      <span class="c2 c0">
                        Breezy warrants that it has and will maintain all
                        necessary licences, consents, and permissions necessary
                        for the performance of its obligations under this
                        agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.p49hy1">
                      <span class="c2 c0">
                        Breezy shall keep the Customer Data secure but shall
                        otherwise be under no obligation to prevent the loss,
                        destruction, alteration or disclosure of Customer Data.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0">
                      <span class="c2 c0">
                        Breezy shall follow its archiving procedures for Breezy
                        Data as set out here (https://breezy.io/privacy). In the
                        event of any loss or damage to Searches, the
                        Customer&#39;s sole and exclusive remedy against Breezy
                        shall be for Breezy to use reasonable commercial
                        endeavours to restore the lost or damaged Search results
                        from the latest back-up of such Search maintained by the
                        Supplier.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="7">
                    <li class="c1 c13 li-bullet-0" id="h.393x0lu">
                      <span class="c4">Customer&#39;s obligations</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.1o97atn">
                      <span class="c2 c0">The Customer shall:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.488uthg">
                      <span class="c2 c0">provide Breezy with:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-3 start" start="1">
                    <li class="c17 li-bullet-0" id="h.2ne53p9">
                      <span class="c2 c0">
                        all necessary co-operation in relation to this
                        agreement; and
                      </span>
                    </li>
                    <li class="c17 li-bullet-0" id="h.12jfdx2">
                      <span class="c2 c0">
                        all necessary access to such information as may be
                        required by Breezy;
                      </span>
                    </li>
                  </ol>
                  <p class="c22">
                    <span class="c2 c0">
                      in order to provide the Services and/or the Add-Ons,
                      including but not limited to Customer Data, security
                      access information and configuration services;
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-2" start="2">
                    <li class="c7 li-bullet-0" id="h.3mj2wkv">
                      <span class="c2 c0">
                        without affecting its other obligations under this
                        agreement, comply with all applicable laws and
                        regulations with respect to its activities under this
                        agreement;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.21od6so">
                      <span class="c2 c0">
                        carry out all other Customer responsibilities set out in
                        this agreement in a timely and efficient manner. In the
                        event of any delays in the Customer&#39;s provision of
                        such assistance as agreed by the parties, Breezy may
                        adjust any agreed timetable or delivery schedule as
                        reasonably necessary;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.gtnh0h">
                      <span class="c2 c0">
                        ensure that the Authorised Users use the Services and
                        the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} in accordance with the terms and
                        conditions of this agreement and shall be responsible
                        for any Authorised User&#39;s breach of this agreement;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.30tazoa">
                      <span class="c2 c0">
                        obtain and shall maintain all necessary licences,
                        consents, and permissions necessary for Breezy, its
                        contractors and agents to perform their obligations
                        under this agreement, including without limitation the
                        Services;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.1fyl9w3">
                      <span class="c2 c0">
                        ensure that its network and systems comply with the
                        relevant specifications provided by Breezy from time to
                        time; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3zy8sjw">
                      <span class="c2 c0">
                        be, to the extent permitted by law and except as
                        otherwise expressly provided in this agreement, solely
                        responsible for procuring, maintaining and securing its
                        network connections and telecommunications links from
                        its systems to Breezy&#39;s data centres, and all
                        problems, conditions, delays, delivery failures and all
                        other loss or damage arising from or relating to the
                        Customer&#39;s network connections or telecommunications
                        links or caused by the internet.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.2f3j2rp">
                      <span class="c2 c0">
                        The Customer shall own all right, title and interest in
                        and to all of the Customer Data that is not personal
                        data and shall have sole responsibility for the
                        legality, reliability, integrity, accuracy and quality
                        of all such Customer Data.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="8">
                    <li class="c1 c13 li-bullet-0" id="h.u8tczi">
                      <span class="c4">Charges and payment</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.3e8gvnb">
                      <span class="c2 c0">
                        The Customer shall pay the Fees to Breezy in advance in
                        accordance with this clause 8 and the Payment Details.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0">
                      <span class="c11">If the Payment Details comprise:</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0">
                      <span class="c2 c0">
                        credit card details, the Customer hereby authorises
                        Breezy to bill such credit card:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_7-3 start" start="1">
                    <li class="c17 li-bullet-0">
                      <span class="c2 c0">
                        on or after the first day of the new subscription period
                        for that period&rsquo;s subscription Fees;
                      </span>
                    </li>
                    <li class="c17 li-bullet-0">
                      <span class="c0">
                        on the parties agreeing in writing the addition of an
                        Ecosystem or Ecosystems, a change in the Services Plan,
                        or provision of any Searches or Contacts in excess of a
                        previous Agreed Threshold or for any &lsquo;Bolt
                        On&rsquo; Contract Credit (as defined in the
                          {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}).
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_7-2 start" start="1">
                    <li class="c7 li-bullet-0">
                      <span class="c2 c0">
                        purchase order information, Breezy shall invoice the
                        Customer:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_7-3 start" start="1">
                    <li class="c17 li-bullet-0">
                      <span class="c2 c0">
                        14 days prior to the commencement of the next
                        subscription period;
                      </span>
                    </li>
                    <li class="c17 li-bullet-0">
                      <span class="c2 c0">
                        on request by the Customer by way of Order Form, any
                        pro-rata increase in the subscription Fee as a result of
                        a change in the Services Tier during the applicable
                        period; and any amounts due under the Services Plan for
                        any Search or Contact made by the Customer in excess of
                        the Agreed Threshold or for any &lsquo;Bolt On&rsquo;
                        Contract Credit (as defined in the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "})
                        requested by the Customer, each in the applicable period
                        and the Customer shall pay each invoice within 14 days
                        after the date of such invoice.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="3">
                    <li class="c1 li-bullet-0">
                      <span class="c2 c0">
                        If Breezy has not received payment by the due date, and
                        without prejudice to any other rights and remedies of
                        Breezy:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.1tdr5v4">
                      <span class="c2 c0">
                        may, without liability to the Customer, disable the
                        Customer&#39;s password, account and access to all or
                        part of the Services and Breezy shall be under no
                        obligation to provide any or all of the Services while
                        the invoice(s) concerned remain unpaid; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.4ddeoix">
                      <span class="c2 c0">
                        interest shall accrue on a daily basis on such due
                        amounts at an annual rate equal to 3% over the then
                        current base lending rate of Breezy&#39;s bankers in the
                        UK from time to time, commencing on the due date and
                        continuing until fully paid, whether before or after
                        judgement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="4">
                    <li class="c1 li-bullet-0" id="h.2sioyqq">
                      <span class="c2 c0">
                        All amounts and fees stated or referred to in this
                        agreement:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.17nz8yj">
                      <span class="c2 c0">
                        shall be payable in pounds sterling;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3rnmrmc">
                      <span class="c2 c0">
                        are non-cancellable and non-refundable;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.26sx1u5">
                      <span class="c2 c0">
                        are exclusive of value added tax, which shall be added
                        to Breezy&#39;s invoice(s) at the appropriate rate.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="5">
                    <li class="c1 li-bullet-0" id="h.ly7c1y">
                      <span class="c2 c0">
                        Breezy shall be entitled to increase the Fees on or
                        around each anniversary of the Effective Date upon 45
                        days&#39; prior notice to the Customer.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="9">
                    <li class="c1 c13 li-bullet-0" id="h.35xuupr">
                      <span class="c4">Proprietary rights</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.1l354xk">
                      <span class="c2 c0">
                        The Customer acknowledges and agrees that Breezy and/or
                        its licensors own all intellectual property rights in
                        the Services, the Add-Ons the Breezy Data and the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}. Except as expressly stated herein, this
                        agreement does not grant the Customer any rights to,
                        under or in, any patents, copyright, database right,
                        trade secrets, trade names, trade marks (whether
                        registered or unregistered), or any other rights or
                        licences in respect of the Services, Breezy Data or the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "}.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.452snld">
                      <span class="c2 c0">
                        Breezy confirms that it has all the rights in relation
                        to the Services, Add-Ons, the Breezy Data and the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} that are necessary to grant all the rights
                        it purports to grant under, and in accordance with, the
                        terms of this agreement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_7-1 start" start="1">
                    <li class="c1 li-bullet-0">
                      <span class="c0">
                        Where the Services are provided as part of a free trial,
                        the Customer has no right to copy or use Breezy Data
                      </span>
                      <span class="c0">.</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="3">
                    <li class="c1 li-bullet-0">
                      <span class="c2 c0">
                        The Customer grants to Breezy a non-exclusive licence to
                        use the Customer&rsquo;s name and logo to identify the
                        Customer as a Breezy customer and any feedback provided
                        by the Customer in respect of the Services and/or the
                        Add-Ons.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="10">
                    <li class="c1 c13 li-bullet-0" id="h.2k82xt6">
                      <span class="c4">
                        Confidentiality and compliance with policies
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.zdd80z">
                      <span class="c11">Confidential Information</span>
                      <span class="c2 c0">
                        &nbsp;means all confidential information (however
                        recorded or preserved) disclosed by a party or its
                        Representatives (as defined below) to the other party
                        and that party&#39;s Representatives whether before or
                        after the date of this agreement, including but not
                        limited to:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.3jd0qos">
                      <span class="c2 c0">
                        any information that would be regarded as confidential
                        by a reasonable business person;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.1yib0wl">
                      <span class="c2 c0">
                        any information developed by the parties in the course
                        of carrying out this agreement and the parties agree
                        that:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-3 start" start="1">
                    <li class="c17 li-bullet-0" id="h.4ihyjke">
                      <span class="c2 c0">
                        Breezy Data shall constitute Breezy Confidential
                        Information; and
                      </span>
                    </li>
                    <li class="c17 li-bullet-0" id="h.2xn8ts7">
                      <span class="c2 c0">
                        Customer Data shall constitute Customer Confidential
                        Information;
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.1csj400">
                      <span class="c2 c0">
                        Each party shall keep the other party&#39;s Confidential
                        Information secret and confidential and shall not use
                        such Confidential Information except for the purpose of
                        exercising or performing its rights and obligations
                        under or in connection with this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.3ws6mnt">
                      <span class="c2 c0">
                        A party may disclose Confidential Information to the
                        extent such Confidential Information is required to be
                        disclosed by law, by any governmental or other
                        regulatory authority or by a court or other authority of
                        competent jurisdiction provided that, to the extent it
                        is legally permitted to do so, it gives the other party
                        as much notice of such disclosure as possible.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2bxgwvm">
                      <span class="c2 c0">
                        In performing its obligations under this agreement the
                        Customer shall comply with the Mandatory Policies.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="11">
                    <li class="c1 c13 li-bullet-0" id="h.r2r73f">
                      <span class="c4">Indemnity</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.3b2epr8">
                      <span class="c2 c0">
                        The Customer shall defend, indemnify and hold harmless
                        Breezy against claims, actions, proceedings, losses,
                        damages, expenses and costs (including without
                        limitation court costs and reasonable legal fees)
                        arising out of or in connection with the Customer&#39;s
                        use of the Services, Add-Ons, Breezy Data and/or
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} except to the extent that they result from
                        Breezy&rsquo;s failure to provide the Services and/or
                        the Add-Ons in accordance with the provisions of this
                        agreement, provided that:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.1q7ozz1">
                      <span class="c2 c0">
                        the Customer is given prompt notice of any such claim;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.4a7cimu">
                      <span class="c2 c0">
                        Breezy provides reasonable co-operation to the Customer
                        in the defence and settlement of such claim, at the
                        Customer&#39;s expense; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.2pcmsun">
                      <span class="c2 c0">
                        the Customer is given sole authority to defend or settle
                        the claim.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.14hx32g">
                      <span class="c2 c0">
                        Breezy shall defend the Customer, its officers,
                        directors and employees against any claim that the
                        Customer&#39;s use of the Services or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} in
                        accordance with this agreement infringes any patent
                        effective as of the Effective Date, copyright, trade
                        mark, database right or right of confidentiality, and
                        shall indemnify the Customer for any amounts awarded
                        against the Customer in judgement or settlement of such
                        claims, provided that:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.3ohklq9">
                      <span class="c2 c0">
                        Breezy is given prompt notice of any such claim;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.23muvy2">
                      <span class="c2 c0">
                        the Customer does not make any admission, or otherwise
                        attempt to compromise or settle the claim and provides
                        reasonable co-operation to Breezy in the defence and
                        settlement of such claim, at Breezy&#39;s expense; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.is565v">
                      <span class="c2 c0">
                        Breezy is given sole authority to defend or settle the
                        claim.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="3">
                    <li class="c1 li-bullet-0" id="h.32rsoto">
                      <span class="c2 c0">
                        In the defence or settlement of any claim, Breezy may
                        procure the right for the Customer to continue using the
                        Services, replace or modify the Services so that they
                        become non-infringing or, if such remedies are not
                        reasonably available, terminate this agreement on 2
                        Business Days&#39; notice to the Customer without any
                        additional liability or obligation to pay liquidated
                        damages or other additional costs to the Customer.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.1hx2z1h">
                      <span class="c2 c0">
                        In no event shall Breezy, its employees, agents and
                        sub-contractors be liable to the Customer to the extent
                        that the alleged infringement is based on:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.41wqhpa">
                      <span class="c2 c0">
                        a modification of the Services, Add-Ons, Breezy Data or
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} by anyone other than Breezy; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.2h20rx3">
                      <span class="c2 c0">
                        the Customer&#39;s use of the Services, Add-Ons, Breezy
                        Data or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} in a manner contrary to the
                        instructions given to the Customer by Breezy; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.w7b24w">
                      <span class="c2 c0">
                        the Customer&#39;s use of the Services, Add-Ons, Breezy
                        Data or {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} after notice of the alleged or
                        actual infringement from Breezy or any appropriate
                        authority.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="5">
                    <li class="c1 li-bullet-0" id="h.3g6yksp">
                      <span class="c2 c0">
                        The foregoing and clause 12.3(b) state the
                        Customer&#39;s sole and exclusive rights and remedies,
                        and Breezy&#39;s (including Breezy&#39;s employees&#39;,
                        agents&#39; and sub-contractors&#39;) entire obligations
                        and liability, for infringement of any patent,
                        copyright, trade mark, database right or right of
                        confidentiality.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="12">
                    <li class="c1 c13 li-bullet-0" id="h.1vc8v0i">
                      <span class="c4">Limitation of liability</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.4fbwdob">
                      <span class="c2 c0">
                        Except as expressly and specifically provided in this
                        agreement:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.2uh6nw4">
                      <span class="c2 c0">
                        the Customer assumes sole responsibility for results
                        obtained from the use of the Services, Add-Ons, Breezy
                        Data and the {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "} by the Customer, and for
                        conclusions drawn from such use. Breezy shall have no
                        liability for any damage caused by errors or omissions
                        in any information, instructions or scripts provided to
                        Breezy by the Customer in connection with the Services
                        and/or the Add-Ons, or any actions taken by Breezy at
                        the Customer&#39;s direction;
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.19mgy3x">
                      <span class="c2 c0">
                        all warranties, representations, conditions and all
                        other terms of any kind whatsoever implied by statute or
                        common law are, to the fullest extent permitted by
                        applicable law, excluded from this agreement; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3tm4grq">
                      <span class="c2 c0">
                        the Services and the <a href="https://breezy.io/platform-documentation">{" "}
                          Platform Documentation
                        </a>{" "} are provided to the
                        Customer on an &quot;as is&quot; basis.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.28reqzj">
                      <span class="c2 c0">
                        Nothing in this agreement excludes the liability of
                        Breezy:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.nwp17c">
                      <span class="c2 c0">
                        for death or personal injury caused by Breezy&#39;s
                        negligence; or
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.37wcjv5">
                      <span class="c2 c0">
                        for fraud or fraudulent misrepresentation.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1" start="3">
                    <li class="c1 li-bullet-0" id="h.1n1mu2y">
                      <span class="c2 c0">
                        Subject to clause 12.1 and clause 12.2:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.471acqr">
                      <span class="c2 c0">
                        Breezy shall not be liable whether in tort (including
                        for negligence or breach of statutory duty), contract,
                        misrepresentation, restitution or otherwise for any loss
                        of profits, loss of business, depletion of goodwill
                        and/or similar losses or loss or corruption of data or
                        information, or pure economic loss, or for any special,
                        indirect or consequential loss, costs, damages, charges
                        or expenses however arising under this agreement; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.2m6kmyk">
                      <span class="c2 c0">
                        Breezy&#39;s total aggregate liability in contract
                        (including in respect of the indemnity at clause 11.2),
                        tort (including negligence or breach of statutory duty),
                        misrepresentation, restitution or otherwise, arising in
                        connection with the performance or contemplated
                        performance of this agreement shall be limited to the
                        total Fees paid for during the 12 months immediately
                        preceding the date on which the claim arose.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="13">
                    <li class="c1 c13 li-bullet-0" id="h.11bux6d">
                      <span class="c4">Term and termination</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.3lbifu6">
                      <span class="c0">
                        This agreement shall, unless otherwise terminated as
                        provided in this clause 13, commence on the Effective
                        Date and shall continue until{" "}
                      </span>
                      <span class="c0">
                        terminated by either party giving written notice to the
                        other party, such notice to take effect prior to or at
                        the end of the Trial Period or the current Services
                        Period
                      </span>

                      <span class="c2 c0">.</span>
                    </li>
                  </ol>
                  <p class="c22 c29" id="h.20gsq1z">
                    <span class="c2 c0"></span>
                  </p>
                  <ol class="c3 lst-kix_list_4-1" start="2">
                    <li class="c1 li-bullet-0" id="h.4kgg8ps">
                      <span class="c2 c0">
                        On expiry of notice served under clause 13.1:
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-2 start" start="1">
                    <li class="c7 li-bullet-0" id="h.2zlqixl">
                      <span class="c2 c0">
                        all licences granted under this agreement shall
                        terminate and the Customer shall immediately cease all
                        use of the Services, the Searches and/or the
                        {" "}<a href="https://breezy.io/platform-documentation">
                          Platform Documentation
                        </a>{" "};
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.1er0t5e">
                      <span class="c2 c0">
                        each party shall return and make no further use of any
                        equipment, property and other items (and all copies of
                        them) belonging to the other party; and
                      </span>
                    </li>
                    <li class="c7 li-bullet-0" id="h.3yqobt7">
                      <span class="c2 c0">
                        any rights, remedies, obligations or liabilities of the
                        parties that have accrued up to the date of termination,
                        including the right to claim damages in respect of any
                        breach of the agreement which existed at or before the
                        date of termination shall not be affected or prejudiced.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="14">
                    <li class="c1 c13 li-bullet-0" id="h.2dvym10">
                      <span class="c4">Force majeure</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.t18w8t">
                    <span class="c2 c0">
                      Neither party shall be in breach of this agreement nor
                      liable for delay in performing, or failure to perform, any
                      of its obligations under this agreement if such delay or
                      failure result from events, circumstances or causes beyond
                      its reasonable control. The time for performance of such
                      obligations shall be extended accordingly.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="15">
                    <li class="c1 c13 li-bullet-0" id="h.3d0wewm">
                      <span class="c4">Variation</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.1s66p4f">
                    <span class="c2 c0">
                      No variation of this agreement shall be effective unless
                      it is in writing and signed by the parties (or their
                      authorised representatives).
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="16">
                    <li class="c1 c13 li-bullet-0" id="h.4c5u7s8">
                      <span class="c4">Waiver</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.2rb4i01">
                      <span class="c2 c0">
                        A waiver of any right or remedy is only effective if
                        given in writing and shall not be deemed a waiver of any
                        subsequent right or remedy.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.16ges7u">
                      <span class="c2 c0">
                        A delay or failure to exercise, or the single or partial
                        exercise of, any right or remedy shall not waive that or
                        any other right or remedy, nor shall it prevent or
                        restrict the further exercise of that or any other right
                        or remedy.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="17">
                    <li class="c1 c13 li-bullet-0" id="h.3qg2avn">
                      <span class="c4">Rights and remedies</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.25lcl3g">
                    <span class="c2 c0">
                      Except as expressly provided in this agreement, the rights
                      and remedies provided under this agreement are in addition
                      to, and not exclusive of, any rights or remedies provided
                      by law.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="18">
                    <li class="c1 c13 li-bullet-0" id="h.kqmvb9">
                      <span class="c4">Severance</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.34qadz2">
                    <span class="c2 c0">
                      If any provision or part-provision of this agreement is or
                      becomes invalid, illegal or unenforceable, it shall be
                      deemed deleted, but that shall not affect the validity and
                      enforceability of the rest of this agreement.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="19">
                    <li class="c1 c13 li-bullet-0" id="h.1jvko6v">
                      <span class="c4">Entire agreement</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.43v86uo">
                      <span class="c2 c0">
                        This agreement and the Mandatory Policies constitute the
                        entire agreement between the parties and supersede and
                        extinguish all previous and contemporaneous agreements,
                        promises, assurances and understandings between them,
                        whether written or oral, relating to its subject matter.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2j0ih2h">
                      <span class="c2 c0">
                        Each party acknowledges that in entering into this
                        agreement it does not rely on, and shall have no
                        remedies in respect of, any statement, representation,
                        assurance or warranty (whether made innocently or
                        negligently) that is not set out in this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.y5sraa">
                      <span class="c2 c0">
                        Each party agrees that it shall have no claim for
                        innocent or negligent misrepresentation or negligent
                        misstatement based on any statement in this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.3i5g9y3">
                      <span class="c2 c0">
                        Nothing in this clause shall limit or exclude any
                        liability for fraud.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="20">
                    <li class="c1 c13 li-bullet-0" id="h.1xaqk5w">
                      <span class="c4">Assignment</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.4hae2tp">
                      <span class="c2 c0">
                        The Customer shall not, without the prior written
                        consent of Breezy, assign, novate, transfer, charge,
                        sub-contract or deal in any other manner with all or any
                        of its rights or obligations under this agreement.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2wfod1i">
                      <span class="c2 c0">
                        Breezy may at any time assign, transfer, charge,
                        sub-contract or deal in any other manner with all or any
                        of its rights or obligations under this agreement.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="21">
                    <li class="c1 c13 li-bullet-0" id="h.1bkyn9b">
                      <span class="c4">No partnership or agency</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.3vkm5x4">
                    <span class="c2 c0">
                      Nothing in this agreement is intended to or shall operate
                      to create a partnership between the parties, or authorise
                      either party to act as agent for the other, and neither
                      party shall have the authority to act in the name or on
                      behalf of or otherwise to bind the other in any way
                      (including, but not limited to, the making of any
                      representation or warranty, the assumption of any
                      obligation or liability and the exercise of any right or
                      power).
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="22">
                    <li class="c1 c13 li-bullet-0" id="h.2apwg4x">
                      <span class="c4">Third party rights</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.pv6qcq">
                    <span class="c2 c0">
                      This agreement does not confer any rights on any person or
                      party (other than the parties to this agreement and, where
                      applicable, their successors and permitted assigns)
                      pursuant to the Contracts (Rights of Third Parties) Act
                      1999.
                    </span>
                  </p>
                  <ol class="c3 lst-kix_list_4-0" start="23">
                    <li class="c1 c13 li-bullet-0" id="h.39uu90j">
                      <span class="c4">Notices</span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-1 start" start="1">
                    <li class="c1 li-bullet-0" id="h.1p04j8c">
                      <span class="c2 c0">
                        Any notice given to a party under or in connection with
                        this agreement shall be in writing and shall be
                        delivered by email to the address provided by each party
                        to the other on subscription for the Services (or an
                        address substituted in writing by the party to be
                        served).
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.48zs1w5">
                      <span class="c2 c0">
                        Any notice shall be deemed to have been received at the
                        time of transmission, or, if this time falls outside
                        Business Hours in the place of receipt, when Business
                        Hours resume.
                      </span>
                    </li>
                    <li class="c1 li-bullet-0" id="h.2o52c3y">
                      <span class="c2 c0">
                        This clause does not apply to the service of any
                        proceedings or other documents in any legal action or,
                        where applicable, any arbitration or other method of
                        dispute resolution.
                      </span>
                    </li>
                  </ol>
                  <ol class="c3 lst-kix_list_4-0" start="24">
                    <li class="c1 c13 li-bullet-0" id="h.13acmbr">
                      <span class="c4">Governing law</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.3na04zk">
                    <span class="c2 c0">
                      This agreement and any dispute or claim arising out of or
                      in connection with it or its subject matter or formation
                      (including non-contractual disputes or claims) shall be
                      governed by and interpreted in accordance with the law of
                      England and Wales.
                    </span>
                  </p>
                  <a id="id.hkkpf6"></a>
                  <ol class="c3 lst-kix_list_4-0" start="25">
                    <li class="c1 c13 li-bullet-0" id="h.22faf7d">
                      <span class="c4">Jurisdiction</span>
                    </li>
                  </ol>
                  <p class="c16" id="h.31k882z">
                    <span class="c2 c0">
                      Each party irrevocably agrees that the courts of England
                      and Wales shall have exclusive jurisdiction to settle any
                      dispute or claim arising out of or in connection with this
                      agreement or its subject matter or formation (including
                      non-contractual disputes or claims) provided that either
                      party may enforce any judgement of the courts of England
                      and Wales in the courts of any jurisdiction.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <div className="pt-48 pb-56">
        <ActionPanel>
          <h2 className="mb-6 text-4 md:mb-8 md:text-8">Join Breezy</h2>

          <p className="mb-10 md:mb-16">
            Join the industry leaders already <strong>finding partners</strong>{" "}
            and benefitting from <strong>market intelligence</strong> from our
            partnership platform.
          </p>

          <div className="max-w-xl mx-auto">
            <SignUpForm />
          </div>
        </ActionPanel>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query customerTerms {
    mdx(fileAbsolutePath: { regex: "//static/customer-terms-index/" }) {
      frontmatter {
        title
        seo {
          description
          title
        }
      }
      body
    }
  }
`

export default CustomerTermsPage
